<template>
  <div class="twitter-post-item-contents-parts">
    <a class="twitter--post-item-contents-parts__link" :href="snsPost.link" target="_blank">
      <sns-post-item-header-parts :snsPost="snsPost" />

      <p class="post-item-contents-parts__text">
        <span v-html="snsPost.post" />
      </p>
    </a>
    <sns-post-item-images-parts
      v-if="snsPost.images.length > 0"
      :images="snsPost.images"
      :postLink="snsPost.link"
      :key="snsPost.link"
      @updateSnsContentsData="updateSnsContentsData"
    />

    <a class="twitter--post-item-contents-parts__link" :href="snsPost.link" target="_blank">
      <div class="post-item-contents-parts__footer">
        <div class="post-item-contents-parts__action-count">
          <p class="post-item-contents-parts__action-count__data">
            <img :src="require('@/assets/img/icon/icon_sns_like.svg')" alt="" />
            <span v-text="snsPost.like" />
          </p>
          <p class="post-item-contents-parts__action-count__data">
            <img :src="require('@/assets/img/icon/icon_sns_retweet.svg')" alt="" />
            <span v-text="snsPost.retweet" />
          </p>
        </div>
        <p class="post-item-contents-parts__time" v-text="snsPost.time" />
      </div>
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import SnsPostItemImagesParts from '@/components/HomePage/HomePane/parts/SnsPostItemImagesParts.vue'
import SnsPostItemHeaderParts from '@/components/HomePage/HomePane/parts/SnsPostItemHeaderParts.vue'
import { SnsPostData } from '@/store/stores/pageStore/HomePage/HomePageStore'

/**
 * HOME SNSコンテンツ 投稿アイテム Twitter用パーツ
 */
export default defineComponent({
  name: 'TwitterPostItemContentsParts',
  components: {
    SnsPostItemImagesParts,
    SnsPostItemHeaderParts,
  },
  props: {
    snsPost: {
      type: Object as PropType<SnsPostData>,
      required: true,
    },
  },
  methods: {
    updateSnsContentsData(src: string) {
      this.$emit('updateSnsContentsData', src)
    },
  },
})
</script>

<style lang="scss" scoped>
.twitter-post-item-contents-parts {
  width: 100%;
}
</style>
